export default "__VITE_ASSET__Inwf2UIv__"